<section class="card" aria-labelledby="roster-title">
  <div class="card__header">
    <h2 class="card__title" id="roster-title">Fiche d'effectif</h2>
    <span>{{ count() }}</span>
  </div>
  <ul class="roster">
    @for (entry of entries(); track entry.codeName) {
      @let out = isOut(entry);
      @let self = entry.codeName === selfCodeName();
      <li class="roster__item" [class.roster__item--out]="out" [class.roster__item--self]="self">
        <img [src]="out ? '/assets/silhouette-out.svg' : '/assets/silhouette.svg'" alt="" />
        <span
          >Agent {{ entry.codeName }}
          @if (self) {
            (vous)
          }
          <span class="first-name">{{ entry.firstName }}</span>
        </span>
        <span class="roster__status">{{ label(entry) }}</span>
      </li>
    }
  </ul>
</section>
